import { Button, ButtonProps, chakra, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { useSignUpPrompt } from '@/hooks/useSignUpPrompt';
import { useAnalyticsLogger } from '@/imports/ui/amplitude/helpers';
import { IRequestDemoView } from '@/imports/ui/amplitude/types';

import { RequestDemoModal } from './components/RequestDemoModal';

export const REGISTER_INTEREST_DEFAULT_TEXT = 'Request a Demo';

type IRequestDemoButtonProps = ButtonProps & {
  options: {
    organizationId: string;
    registerInterestTitle: string | null;

    origin: {
      conferenceBoothId?: string;
      sponsoredEventId?: string;
      sponsoredConferenceSessionId?: string;
      hostedEventId?: string;
      sponsorPage?: boolean;
      featuredSponsorCard?: boolean;
    };

    analytics: {
      view: IRequestDemoView;
      tier: string;
    };
  };
};

export const RequestDemoButton: React.FC<IRequestDemoButtonProps> = ({
  options,
  ...props
}) => {
  const analyticsClient = useAnalyticsLogger();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { promptModal, withPrompt } = useSignUpPrompt();

  const registerInterestTitle =
    options.registerInterestTitle || REGISTER_INTEREST_DEFAULT_TEXT;

  return (
    <>
      {promptModal}
      <RequestDemoModal
        isOpen={isOpen}
        onClose={onClose}
        organizationId={options.organizationId}
        registerInterestTitle={registerInterestTitle}
        origin={options.origin}
        analytics={options.analytics}
      />
      <Button
        whiteSpace="normal"
        {...props}
        onClick={withPrompt(() => {
          onOpen();
          analyticsClient.logEvent_comm_click_launch_lead_form({
            view: options.analytics.view,
            'sponsor id': options.organizationId,
            'button text': registerInterestTitle,
            tier: options.analytics.tier,
          });
        })}
        id="requestDemoButton"
      >
        <chakra.span noOfLines={1} wordBreak="break-all">
          {registerInterestTitle}
        </chakra.span>
      </Button>
    </>
  );
};
